import { render, staticRenderFns } from "./split-line.vue?vue&type=template&id=3445376b&scoped=true&"
import script from "./split-line.vue?vue&type=script&lang=js&"
export * from "./split-line.vue?vue&type=script&lang=js&"
import style0 from "./split-line.vue?vue&type=style&index=0&id=3445376b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445376b",
  null
  
)

export default component.exports